<script lang="ts">
    import { getBorderRadius } from '$lib/global/helper/border-radius';
    import { cn } from '$lib/utils/cn';

    import {
        createDropdownButtonKeyHandler,
        focusButtonAtIndex,
    } from './dropdownKeyboardNavigation';

    export let open = false;
    export let choices: string[] = [];
    export let selectedChoices: string[] = [];
    export let value = '';
    export let twoColumn = false;
    export let handleSelect: (event: MouseEvent, option: string) => void;
    export let inputElement: HTMLElement | null = null;

    let dropdownElement: HTMLDivElement;
    let focusedIndex = 0;

    $: if (choices.length > 0 && focusedIndex >= choices.length) {
        focusedIndex = 0;
    }

    const handleButtonKeyDown = (event: KeyboardEvent, index: number) => {
        if (!open) return;

        const handler = createDropdownButtonKeyHandler(
            {
                currentIndex: index,
                itemCount: choices.length,
                returnElement: inputElement,
            },
            (newIndex) => {
                focusedIndex = newIndex;

                if (dropdownElement) {
                    focusButtonAtIndex(dropdownElement, newIndex);
                }
            },
        );

        handler(event);
    };

    const contentClasses = cn('fun-grid fun-gap-2 fun-p-4', {
        'fun-grid-cols-2': twoColumn,
    });

    const borderRadius = getBorderRadius('dropdownItem');
</script>

<div class="fun-pointer-events-auto fun-w-full fun-overflow-auto" bind:this={dropdownElement}>
    {#if !!choices}
        <div class={contentClasses}>
            {#each choices as option, index (`${option}-${index}`)}
                <button
                    on:click={(event) => open && handleSelect(event, option)}
                    on:focus={() => (focusedIndex = index)}
                    on:keydown={(e) => handleButtonKeyDown(e, index)}
                    tabindex={open ? 0 : -1}
                    class={cn(
                        'focus:fun-border-1 fun-border fun-py-2.5 fun-text-sm fun-transition hover:fun-bg-gray-50 focus:fun-border-blue-500 focus:fun-bg-blue-50 md:fun-text-base',
                        borderRadius,
                    )}
                    class:fun-bg-blue-50={selectedChoices.includes(option) || value === option}
                    class:fun-text-blue-500={selectedChoices.includes(option) || value === option}
                    class:fun-border-blue-500={selectedChoices.includes(option) || value === option}
                    class:fun-text-gray-500={!selectedChoices.includes(option) && value !== option}
                    class:fun-border-gray-200={!selectedChoices.includes(option) &&
                        value !== option}>{option}</button
                >
            {/each}
        </div>
    {:else}<p class="text-sm">No data</p>{/if}
</div>
